"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRandomNumbers = exports.useWindowEventListener = exports.useMountedState = void 0;
var lodash_1 = require("lodash");
var react_1 = require("react");
function useMountedState() {
    var mountedRef = (0, react_1.useRef)(false);
    var get = (0, react_1.useCallback)(function () { return mountedRef.current; }, []);
    (0, react_1.useLayoutEffect)(function () {
        mountedRef.current = true;
        return function () {
            mountedRef.current = false;
        };
    }, []);
    return get;
}
exports.useMountedState = useMountedState;
function useWindowEventListener(event, listener, debounceInterval) {
    if (debounceInterval === void 0) { debounceInterval = 0; }
    (0, react_1.useEffect)(function () {
        var finalListener = debounceInterval ? (0, lodash_1.debounce)(listener, debounceInterval) : listener;
        window.addEventListener(event, finalListener);
        return function () { return window.removeEventListener(event, finalListener); };
    }, [event, listener, debounceInterval]);
}
exports.useWindowEventListener = useWindowEventListener;
function useRandomNumbers(_a) {
    var _b = _a.number, number = _b === void 0 ? 3 : _b, range = _a.range;
    return (0, react_1.useMemo)(function () { return (0, lodash_1.map)(Array(number), function (_) { return (0, lodash_1.random)(range.start, range.end); }); }, [number, range.end, range.start]);
}
exports.useRandomNumbers = useRandomNumbers;
var miscHooks = {
    useMountedState: useMountedState,
    useWindowEventListener: useWindowEventListener,
    useRandomNumbers: useRandomNumbers,
};
exports.default = miscHooks;
